import React from "react";
import { RealisationsTemplate } from "../../../components/templates";

function Realisations() {
  return <RealisationsTemplate />;
}

export default Realisations;
